import React, {ReactNode, useMemo} from 'react'
import {defineStyles, useThemedStyles} from './styles/style'

import {ActionButton} from './ActionButton'
import {SVG} from '.'
import {StyleValues} from './styles/types'
import {containerBorderRadius} from './shared'

interface Props {
  onDismissed?: () => void
  children: ReactNode
  style?: StyleValues
}

export function MarketingBanner({children, style, onDismissed}: Props) {
  const s = useThemedStyles(styles)

  const containerStyle = useMemo(() => {
    return {
      ...s.bannerContainer,
      ...style
    }
  }, [style, s.bannerContainer])

  return (
    <div style={containerStyle}>
      {onDismissed ? (
        <ActionButton
          onClick={onDismissed}
          style={s.closeButton}
          appearance="plain"
          size="small"
          iconCreator={(color) => <SVG.CloseSmall color={color} />}
        />
      ) : null}
      {children}
    </div>
  )
}

const styles = defineStyles((t) => ({
  bannerContainer: {
    ...t.elevation.level1,
    position: 'relative',
    borderRadius: containerBorderRadius,
    width: `100%`,
    marginBottom: '42px',
    backgroundColor: t.secondary.containerHover,
    padding: '24px'
  },

  closeButton: {
    width: '22px',
    height: '22px',
    position: 'absolute',
    top: '10px',
    right: '10px'
  }
}))
